export const quotes = [
  "“It’s all a question of imagination. Our responsibility begins with the power to imagine.”",
  "“I have to get stronger—like a stray crow.”",
  "“You can never put it back together like it was.”",
  "“You're you, you see, and nobody else. You are you, right?”",
  "“People are drawn deeper into tragedy not by their defects but by their virtues.”",
  "“Things outside you are projections of what’s inside ... what’s inside ... is a projection of what’s outside.”",
  "“What I think is this: You should give up looking for lost cats and start searching for the other half of your shadow.”",
  "“As individuals each of us is extremely isolated, while ... all linked by a prototypical memory.”",
  "“What seems threatening is just the echo of the fear in my own heart.”",
  "“I ... feel an omen calling out to me, like a dark, omnipresent pool of water.”",
  "“But the longer I’ve lived, the more I’ve lost what’s inside me—and ended up empty.”",
  "“And once the storm is over you won’t remember how you made it through, how you managed to survive. You won’t even be sure, in fact, whether the storm is really over. But one thing is certain. When you come out of the storm you won’t be the same person who walked in. That’s what this storm’s all about.”",
  "“Everything is there, but there are no parts.”",
  "“If you remember me, then I don’t care if everyone else forgets.”",
  "“Move from reason that observes to reason that acts.”",
  "“Sometimes fate is like a small sandstorm that keeps changing directions.”",
  "“Silence, I discover, is something you can actually hear.”",
  "“Taking crazy things seriously is a serious waste of time.”",
  "“Chance encounters are what keep us going.”",
  "“A certain type of perfection can only be realized through a limitless accumulation of the imperfect.”",
];
